// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet communicatie-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainEntityReferencesSbEntityType =
  (typeof SUREbusinessCommonDomainEntityReferencesSbEntityType)[keyof typeof SUREbusinessCommonDomainEntityReferencesSbEntityType];

export const SUREbusinessCommonDomainEntityReferencesSbEntityType = {
  InspectieAanvraag: 'InspectieAanvraag',
  Maatwerk: 'Maatwerk',
  Aanvraag: 'Aanvraag',
  KantoorDocument: 'KantoorDocument',
} as const;
